<template>

<div class="mn">

  <div @click="showDefault()">
    <svg viewBox="0 0 80 80">
     <g id="m_default">
      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(100%,98.823529%,98.823529%);fill-opacity:1;" d="M 221.917969 237.78125 C 220.988281 238.25 220.636719 239.15625 220.632812 241.085938 C 220.625 243.882812 221.660156 247.609375 223.363281 250.953125 C 224.738281 253.644531 225.019531 254.019531 226.757812 255.441406 C 229.90625 258.019531 236.964844 261.160156 241.078125 261.816406 C 241.957031 261.953125 243.125 262.226562 243.675781 262.421875 C 244.226562 262.613281 245.199219 262.855469 245.832031 262.957031 C 246.464844 263.058594 247.855469 263.351562 248.914062 263.613281 C 253.609375 264.757812 256.632812 265.019531 265.242188 265.019531 L 273.472656 265.019531 L 277.167969 263.53125 C 282.566406 261.359375 285.566406 259.703125 287.191406 257.984375 C 288.957031 256.121094 290.570312 250.234375 290.570312 245.667969 C 290.570312 242.027344 289.746094 241.042969 286.714844 241.058594 C 284.164062 241.070312 283.816406 241.316406 282.410156 244.121094 C 281.503906 245.921875 280.964844 246.6875 280.332031 247.070312 C 279.863281 247.351562 278.71875 248.175781 277.789062 248.898438 C 276.597656 249.824219 275.097656 250.621094 272.726562 251.589844 L 269.355469 252.964844 L 264.984375 252.957031 C 260.519531 252.945312 256.679688 252.570312 253.929688 251.878906 C 253.078125 251.667969 251.628906 251.339844 250.703125 251.15625 C 246.453125 250.304688 241.40625 248.410156 238.148438 246.449219 C 237.210938 245.882812 236.039062 245.28125 235.546875 245.109375 C 235.058594 244.9375 234.09375 244.238281 233.410156 243.554688 C 232.65625 242.800781 231.28125 241.867188 229.929688 241.1875 C 228.679688 240.558594 227.25 239.601562 226.679688 239.011719 C 225.28125 237.566406 223.339844 237.066406 221.917969 237.78125 "/>
     </g>
    </svg>
  </div>


</div>

</template>


<script>
export default {
  name: "OptionsMouths",
  methods: {
    deleteClass() {
      let c = document.getElementById('mouths').children, i;
      for (i = 0; i < c.length; i++) {
        c[i].classList.remove('show');
      }
    },
    showVomit() {
      this.deleteClass();
      document.querySelector('#m_vomit').classList.add('show');
    },
    showTwinkle() {
      this.deleteClass();
      document.querySelector('#m_twinkle').classList.add('show');
    },
    showTongue() {
      this.deleteClass();
      document.querySelector('#m_tongue').classList.add('show');
    },
    showSmile() {
      this.deleteClass();
      document.querySelector('#m_smile').classList.add('show');
    },
    showSerious() {
      this.deleteClass();
      document.querySelector('#m_serious').classList.add('show');
    },
    showScream() {
      this.deleteClass();
      document.querySelector('#m_scream').classList.add('show');
    },
    showGrimace() {
      this.deleteClass();
      document.querySelector('#m_grimace').classList.add('show');
    },
    showEating() {
      this.deleteClass();
      document.querySelector('#m_eating').classList.add('show');
    },
    showDisbelief() {
      this.deleteClass();
      document.querySelector('#m_disbelief').classList.add('show');
    },
    showDefault() {
      this.deleteClass();
      document.querySelector('#m_default').classList.add('show');
    },
    showConcerned() {
      this.deleteClass();
      document.querySelector('#m_concerned').classList.add('show');
    }
  }
}
</script>
